import { useEffect, Fragment } from 'react';
import { getIsPrerenderUserAgent } from '../../utils/userAgent';
import { jsx as _jsx } from "react/jsx-runtime";
const PrerenderReady = ({
  ready = true,
  statusCode
}) => {
  const isPrerenderUserAgent = getIsPrerenderUserAgent();
  const prerenderReady = isPrerenderUserAgent && ready;
  useEffect(() => {
    if (prerenderReady) {
      window.prerenderReady = true;
      return () => {
        window.prerenderReady = false;
      };
    }
    return () => {};
  }, [prerenderReady]);
  if (!prerenderReady) {
    return null;
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: statusCode && /*#__PURE__*/_jsx("meta", {
      name: "prerender-status-code",
      content: `${statusCode}`,
      "data-test-id": "prerender-status-code"
    })
  });
};
export default PrerenderReady;